import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

export const isMerchant = (userRole: string | null | undefined) =>
  userRole === AccessRoleCodes.Merchant;

export const useIsCurrentUserMerchant = () => {
  const userRole = useCurrentUserAccessRole();

  return isMerchant(userRole);
};
